import { createFormatForDescription as cffd } from '../createFormatForDescription'
import { Explanation, explain } from '../explain/Explanation'
import CheckCancelInstructions from '../types/instructions/CheckCancelInstructions'
import TransactionType from '../types/TransactionType'

/**
 * An explanation of a CheckCancel transaction.
 *
 * @property type - The type of the transaction.
 * @property checkId - An explanation of the checkId.
 */
export interface CheckCancelAnnotation {
  readonly type: TransactionType.CheckCancel
  readonly checkId: Explanation<string>
}

/**
 * Takes a transaction object and returns an annotated transaction object.
 * The returned object contains explanations about the various transaction features.
 *
 * @param transactionInstructions - The input transaction.
 * @returns An annotated transaction object detailing the various transaction features.
 */
export function annotate(
  transactionInstructions: CheckCancelInstructions,
): CheckCancelAnnotation {
  const checkId = explain(
    transactionInstructions.CheckID,
    `The check with id ${cffd(
      transactionInstructions.CheckID,
      'checkId',
    )} will be cancelled.`,
  )

  return {
    checkId,

    type: TransactionType.CheckCancel,
  }
}
